var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMeestLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 25,
    fill: "none",
    viewBox: "0 0 95 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_13a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    d: "M16.047 24.25 20.61 5.823l1.224 18.812h5.12L25.394.645h-7.996L13.482 16.77 9.557.645H1.56L0 24.635h5.12l1.225-18.81 4.564 18.425h5.139Zm68.43-14.517h3.085l1.068-1.977-1.058-1.941h-3.095zm-8.826 0h2.702v7.774c0 4.084 1.022 7.129 5.494 7.129 1.616 0 2.958-.414 3.715-.718v-4.36c-2.674.506-3.98.672-3.98-2.916V.636h-5.23v5.188h-2.29l-.411 3.91ZM51.079 16.78c.356 4.526 7.348 3.735 10.369 2.778l.748 3.91c-7.074 2.722-16.512.947-16.512-8.325 0-12.355 17.526-13.698 17.526-.645 0 .985-.11 1.859-.183 2.273H51.079zm6.827-3.947c0-5.105-6.836-5.178-6.79 0zm11.191-2.042c0-2.355 4.345-1.591 5.66-1.058l.4-3.91c-4.399-1.37-11.226-.349-11.217 5.493-.091 5.758 8.324 4.967 8.324 7.708 0 2.889-6.59 1.408-8.023.534l-.748 3.919c4.892 2.18 14.193 1.692 13.947-4.848-.082-6.357-8.343-5.234-8.343-7.838"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E82A53",
    d: "M32.65 16.78c.356 4.526 7.348 3.735 10.37 2.778l.748 3.91c-7.074 2.722-16.512.947-16.512-8.326 0-12.354 17.525-13.697 17.525-.644 0 .985-.11 1.859-.182 2.273H32.65zm6.828-3.947c0-5.105-6.837-5.179-6.791 0h6.79ZM90.356.636l3.888 7.12-3.888 7.166h-3.889l3.889-7.166-3.889-7.12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_13a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .636h94.244v24H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMeestLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/meest-logo.288634f3675c0408a81419b9fbcc8cf3.svg";